// extracted by mini-css-extract-plugin
module.exports = {"container":"OfflineOrders_container__PX9mb","table-container":"OfflineOrders_table-container__VQEL0","table":"OfflineOrders_table__3_blM"};